import { MAX_NAVIGATION_BAR_WIDTH, MIN_NAVIGATION_BAR_WIDTH } from './getLeftNavWidth';
import setShowFolderPane from './setShowFolderPane';
import updateNavigationBarWidth from '../services/updateNavigationBarWidth';
import mailStore from 'owa-mail-store/lib/store/Store';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { action, select } from 'satcheljs/lib/legacy';
/**
 * Set the folder pane width
 * @param width the with of folder pane width
 * @param state the SetFolderPaneWidthState which contains user options
 */
export default action('setFolderPaneWidth')(select({
    userOptions: function () { return getUserConfiguration().UserOptions; },
})(function setFolderPaneWidth(width, folderPaneExpansionSource, state) {
    if (width == state.userOptions.NavigationBarWidth) {
        // No-op when new width is the same as the saved width in userOptions
        return;
    }
    var newNavigationBarWidth;
    if (width < MIN_NAVIGATION_BAR_WIDTH) {
        if (mailStore.mailModule.showFolderPane) {
            // Set the width to minimum
            newNavigationBarWidth = MIN_NAVIGATION_BAR_WIDTH;
        }
        else {
            // User drags the folder pane when it's collapsed, we should expand the folder pane
            newNavigationBarWidth = Math.min(width, MAX_NAVIGATION_BAR_WIDTH);
        }
    }
    else {
        // Folder pane should be expanded
        // Make sure the width doesn't exceed the max threshold
        newNavigationBarWidth = Math.min(width, MAX_NAVIGATION_BAR_WIDTH);
    }
    setShowFolderPane(folderPaneExpansionSource);
    state.userOptions.NavigationBarWidth = newNavigationBarWidth;
    updateNavigationBarWidth(state.userOptions.NavigationBarWidth);
}));
//# sourceMappingURL=setFolderPaneWidth.js.map